import { render, staticRenderFns } from "./InputPhoneNumber.vue?vue&type=template&id=e8fa82a8&"
import script from "./InputPhoneNumber.vue?vue&type=script&lang=js&"
export * from "./InputPhoneNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports